define('selerix_common/vues/components/modal/Modal.vue', ['vue'], function (Vue) {
    'use strict';
    Vue = Vue && Object.prototype.hasOwnProperty.call(Vue, 'default') ? Vue['default'] : Vue;
    var ExtensionObject = {
        name: 'Modal',
        props: {
            theme: {
                type: String,
                default: 'default'
            },
            size: {
                type: String,
                default: 'md'
            },
            title: {
                type: String,
                default: ''
            },
            titleLang: {
                type: String,
                default: null
            },
            defaultButton: {
                type: String,
                default: null
            },
            backdrop: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                originalDefaultBtn: ''
            };
        },
        computed: {
            sizeClass: function () {
                return "modal-" + this.size;
            },
            bgClass: function () {
                return "bg-" + this.theme;
            },
            userLang: function () {
                var lang = $('html[lang]').attr('lang');
                return lang === undefined || lang === 'en' ? null : lang;
            },
            titleId: function () {
                return this.$attrs.id + "_title";
            }
        },
        mounted: function () {
            var _this = this;
            this.$nextTick(function () {
                if (!_this.defaultButton)
                    return;
                var orgDefaultBtn = $('#gDefaultButtonID');
                if (!orgDefaultBtn.length)
                    return;
                _this.originalDefaultBtn = orgDefaultBtn.val();
                $(_this.$el).on('shown.bs.modal', function () {
                    orgDefaultBtn.val(_this.defaultButton);
                }).on('hidden.bs.modal', function () {
                    orgDefaultBtn.val(_this.originalDefaultBtn);
                });
            });
        }
    };
    var script = Vue.extend(ExtensionObject);
    function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
        if (typeof shadowMode !== 'boolean') {
            createInjectorSSR = createInjector;
            createInjector = shadowMode;
            shadowMode = false;
        }
        var options = typeof script === 'function' ? script.options : script;
        if (template && template.render) {
            options.render = template.render;
            options.staticRenderFns = template.staticRenderFns;
            options._compiled = true;
            if (isFunctionalTemplate) {
                options.functional = true;
            }
        }
        if (scopeId) {
            options._scopeId = scopeId;
        }
        var hook;
        if (moduleIdentifier) {
            hook = function (context) {
                context =
                    context ||
                        (this.$vnode && this.$vnode.ssrContext) ||
                        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext);
                if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                    context = __VUE_SSR_CONTEXT__;
                }
                if (style) {
                    style.call(this, createInjectorSSR(context));
                }
                if (context && context._registeredComponents) {
                    context._registeredComponents.add(moduleIdentifier);
                }
            };
            options._ssrRegister = hook;
        }
        else if (style) {
            hook = shadowMode
                ? function (context) {
                    style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
                }
                : function (context) {
                    style.call(this, createInjector(context));
                };
        }
        if (hook) {
            if (options.functional) {
                var originalRender_1 = options.render;
                options.render = function renderWithStyleInjection(h, context) {
                    hook.call(context);
                    return originalRender_1(h, context);
                };
            }
            else {
                var existing = options.beforeCreate;
                options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
            }
        }
        return script;
    }
    var __vue_script__ = script;
    var __vue_render__ = function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("div", {
            staticClass: "modal fade",
            attrs: {
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": _vm.titleId,
                "data-backdrop": _vm.backdrop
            }
        }, [
            _c("div", {
                staticClass: "modal-dialog",
                class: _vm.sizeClass,
                attrs: { role: "document" }
            }, [
                _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header", class: _vm.bgClass }, [
                        _c("button", {
                            staticClass: "close",
                            attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                                "aria-label": "Close",
                                lang: _vm.userLang
                            }
                        }, [
                            _c("span", { class: _vm.bgClass, attrs: { "aria-hidden": "true" } }, [_vm._v("×")])
                        ]),
                        _vm._v(" "),
                        _c("h4", {
                            staticClass: "modal-title",
                            attrs: { id: _vm.titleId, lang: _vm.titleLang },
                            domProps: { innerHTML: _vm._s(_vm.title) }
                        })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                        _vm._t("buttons", [
                            _c("button", {
                                staticClass: "btn btn-default",
                                attrs: {
                                    type: "button",
                                    "data-dismiss": "modal",
                                    lang: _vm.userLang
                                }
                            }, [_vm._v("Close")])
                        ])
                    ], 2)
                ])
            ])
        ]);
    };
    var __vue_staticRenderFns__ = [];
    __vue_render__._withStripped = true;
    var __vue_inject_styles__ = undefined;
    var __vue_scope_id__ = undefined;
    var __vue_module_identifier__ = undefined;
    var __vue_is_functional_template__ = false;
    var __vue_component__ = normalizeComponent({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
    return __vue_component__;
});
